import { formatPrice } from '@ab-core/functions';
import type { PositionPriceObject } from '@ab-core/graphql/dist/index';
import { Icon } from '@ab-core/icon';
import Text, { FontTypes } from '@ab-core/text';
import type { FC } from 'react';
import React from 'react';
import { Total, TotalCartPrice } from './styled';

type PriceBadgeProps = {
    positionPrice?: PositionPriceObject;
};

export const PriceBadge: FC<PriceBadgeProps> = (props) => {
    const { positionPrice } = props;

    return (
        <TotalCartPrice>
            <Icon name="CheckCircled" color="gray50" size="SMALL_4" />
            <Total>Gesamt</Total>
            <Text type={FontTypes.Price}>{positionPrice?.value && formatPrice(positionPrice?.value)}</Text>
        </TotalCartPrice>
    );
};
